<template>
  <div style="display: flex; flex-direction: column; justify-content: center; height: 100%">
    <div v-for="(pair, index) in item.subjects" :key="index">
      <div style="display: flex; justify-content: space-between; padding-top: 10px; padding-bottom: 10px">
        <v-row no-gutters>
          <v-col cols="12" lg="4"> {{ pair.name }} </v-col>
          <v-col cols="12" lg="4"> {{ pair.startTime | getDate }} </v-col>
          <v-col cols="12" lg="4">
            <span>
              <template v-if="getRoomInfo(pair.id)">
                {{ getRoomInfo(pair.id).name }} - {{ getRoomInfo(pair.id).location }}
              </template>
              <template v-else>
                Chưa có thông tin phòng
              </template>
            </span>
          </v-col>
        </v-row>
      </div>
      <v-divider v-if="index < item.subjects.length - 1"></v-divider>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  props: {
    item: Object
  },
  methods: {
    getRoomInfo(subjectId) {
      // Check if item.data and item.data.room exist
      if (!this.item.data || !this.item.data.room) {
        return null
      }

      // Proceed to find the room if the data exists
      for (const roomId in this.item.data.room) {
        if (this.item.data.room[roomId].includes(subjectId)) {
          return this.item.rooms.find(room => room._id === roomId)
        }
      }

      return null
    }
  },
  filters: {
    getDate: item => {
      if (item) {
        return moment(item)
          .utcOffset(7)
          .format('DD/MM/YYYY, [lúc] HH:mm')
      }
      return 'Chưa có thông tin'
    }
  }
}
</script>
